import * as React from 'react';
import { navigation, errorForm } from '@origin-digital/reporting-client';
import { ErrorView } from './ErrorView';
import { IContent } from '../../../../login/interfaces/index';
import { get } from 'lodash';
import { getHashOrQueryParam } from 'ts/window/WindowUtils';
import {
  errorCodeToAnalyticsErrorCode,
  errorCodeToAnalyticsErrorMessage,
} from '../../../../services/analytics';
import { getLoginBootstrapUrl } from 'ts/config/ConfigService';
import { FLOW_PARAM, REDIRECT_URL_PARAM, BROWSER_BACK } from 'ts/constants/UrlParams';
import { ErrorFlow } from './ErrorFlow';

const content: IContent = require('../../../../content.json');

interface ErrorPageState {
  title: string;
  errorMessage: string;
}

interface ErrorPageProps {
  match?: any;
  history: any;
}

interface Error {
  heading: string;
  body: string;
}

// maps flow to friendly uri for analytics
const errorFlowToAnalyticsPageName = {
  [ErrorFlow.login]: 'login',
  [ErrorFlow.register]: 'auth:register',
  [ErrorFlow.registerResetPassword]: 'auth:register-password',
  [ErrorFlow.resetPassword]: 'forgot-password',
  [ErrorFlow.callCentreResetPassword]: 'auth:registration-manual',
  [ErrorFlow.forgotEmail]: 'auth:forgot-email',
  [ErrorFlow.manualReg]: 'auth:manual-reg',
};

const errorFlowToAnalyticsTaskName = {
  [ErrorFlow.login]: 'login',
  [ErrorFlow.register]: 'my-account-registration',
  [ErrorFlow.registerResetPassword]: 'my-account-registration',
  [ErrorFlow.resetPassword]: 'forgot-password-new',
  [ErrorFlow.callCentreResetPassword]: 'auth:registration-manual',
  [ErrorFlow.forgotEmail]: 'forgot-email',
  [ErrorFlow.manualReg]: 'auth:manual-reg',
};

class ErrorPage extends React.PureComponent<ErrorPageProps, ErrorPageState> {
  public componentDidMount() {
    const errorFlow = getHashOrQueryParam(FLOW_PARAM) as ErrorFlow;
    navigation('screen', {
      currentUri: '',
      friendlyUri: `originenergy:my-account:${errorFlowToAnalyticsPageName[errorFlow] ||
        'login'}:error`,
    });
    const errorCode = this.props.match.params.code;
    if (errorCode) {
      errorForm({
        errorCode: errorCodeToAnalyticsErrorCode(errorCode),
        errorMessage: errorCodeToAnalyticsErrorMessage(errorCode),
        formName: errorFlowToAnalyticsTaskName[errorFlow] || 'login',
      });
    }
  }

  public render() {
    const { match } = this.props;
    const { code: errorMatchParam } = match.params;
    const error = get(content.errors, errorMatchParam, content.errors.generic_error) as Error;

    const useBrowserBack = getHashOrQueryParam(BROWSER_BACK);
    const redirectUrl = getHashOrQueryParam(REDIRECT_URL_PARAM);
    let backHref = redirectUrl || getLoginBootstrapUrl();
    let onBackButtonClicked;
    if (useBrowserBack) {
      backHref = '#';
      onBackButtonClicked = this.goBack;
    }

    return (
      <ErrorView
        onBackButtonClicked={onBackButtonClicked}
        backHref={backHref}
        errorMessage={error.body}
        title={error.heading}
      />
    );
  }

  private goBack = () => {
    this.props.history.goBack();
  };
}

export { ErrorPage };
